import { GoalMessageKeys } from '@ag-common-lib/public-api';
import { BaseModel } from 'ag-common-lib/lib/models/base.model';
import { Delta } from 'jsondiffpatch/lib/types';

export enum GoalCommentHistoryAction {
  create = 'create',
  update = 'update',
  remove = 'remove',
}
/*
* Log History format: array of entries:
[
  {
    "action": "create",
    "log": { "text": ["New comment"], "authorDbId": ["agent-id"], ... },
    "created_date": "...",
    ...
  },
  {
    "action": "update",
    "log": { "text": ["Old text", "New text"] },
    "updated_date": "...",
    ...
  }
]
* */
export interface GoalCommentLogHistoryEntry extends BaseModel {
  action: GoalCommentHistoryAction;
  log: Delta;
}

export enum GoalCommentRowKeys {
  id = 'id',
  year = 'year', // Production Year
  timestamp = GoalMessageKeys.timestamp,
  authorDbId = GoalMessageKeys.authorDbId,
  authorName = 'authorName',
  text = GoalMessageKeys.text,
  logHistory = 'logHistory',
}

const COMMENT_MIN_YEAR = 2015;
const CURRENT_YEAR = new Date().getFullYear();

export const GOAL_COMMENT_YEARS: number[] = Array.from(
  { length: CURRENT_YEAR - COMMENT_MIN_YEAR + 1 },
  (_, index) => CURRENT_YEAR - index,
);

export const GOAL_COMMENT_YEAR_LOOKUP = GOAL_COMMENT_YEARS.map(year => ({
  value: year,
  text: String(year),
}));

export const GOAL_COMMENT_YEAR_HEADER_FILTER = {
  dataSource: GOAL_COMMENT_YEAR_LOOKUP,
  allowSearch: true,
  height: 300,
  width: 252,
};

export type GoalCommentRow = Partial<BaseModel> & {
  [GoalCommentRowKeys.id]: string;
  [GoalCommentRowKeys.year]: number;
  [GoalCommentRowKeys.timestamp]: string | Date;
  [GoalCommentRowKeys.authorDbId]: string;
  [GoalCommentRowKeys.authorName]: string;
  [GoalCommentRowKeys.text]: string;
  [GoalCommentRowKeys.logHistory]?: GoalCommentLogHistoryEntry[];
};
